<template>
        <b-container class="card-container">
            <b-row class="mt-3 text-center">
                <b-col cols="12">
                        <slot/>
                </b-col>
            </b-row>
        </b-container>
</template>


<script>
    export default {
        name: 'Cards',
        props: {
            title: String,
            image: String
        }
    }
</script>

<style>
    .card-container ~ .card-container{
        margin-top:30px;
    }
    .card-container{
        margin-top: 0px;
    }
</style>